import { all_routes } from "../../../router/backendComponents/admin/all_routes";

const route = all_routes;

/**
 * Sidebar menu structure
 * Supports unlimited nesting + permission-based rendering
 */
export interface SidebarMenu {
  submenuHdr?: string;
  submenuOpen?: boolean;

  // menu item
  label?: string;
  link?: string;
  code?: string;
  icon?: string;
  submenu?: boolean;
  showSubRoute?: boolean;

  // permission
  subMenuCodeList?: string[];

  // children
  submenuItems?: SidebarMenu[];
}

/**
 * Sidebar menu configuration
 */
export const SidebarData: SidebarMenu[] = [
  {
    submenuOpen: true,
    submenuHdr: "Business Summary",
    subMenuCodeList: ["expenses", "performance_report", "financial_report", 'view_expenses', 'add_new_expenses', 'edit_expenses'],
    submenuItems: [
      {
        label: "Business Summary",
        icon: "ti ti-presentation-analytics",
        submenu: true,
        subMenuCodeList: ["expenses", 'view_expenses', 'add_new_expenses', 'edit_expenses'],
        submenuItems: [
          {
            label: "Expenses Report",
            link: route.expences,
            code: "expenses",
          },
          {
            label: "Sale Report",
            submenu: true,
            subMenuCodeList: ["financial_report", "performance_report"],
            submenuItems: [
              {
                label: "Financial Records",
                link: route.saleReport,
                code: "financial_report",
              },
              {
                label: "Performance Report",
                link: route.performanceReport,
                code: "performance_report",
              },
            ],
          },
        ],
      },
    ],
  },

  {
    submenuOpen: true,
    submenuHdr: "Finance & Accounts",
    subMenuCodeList: [
      "partial_order",
      "quotation_detail",
      "quotation_report",
      "quotation_summary",
      "order",
      "invoice",
      "order_summary",
      "order_report",
    ],
    submenuItems: [
      {
        label: "Sales Insight",
        icon: "ti ti-file-description",
        submenu: true,
        subMenuCodeList: [
          "partial_order",
          "quotation_detail",
          "quotation_report",
          "quotation_summary",
          "order",
          "invoice",
          "order_summary",
          "order_report",
        ],
        submenuItems: [
          {
            label: "Quotation",
            submenu: true,
            subMenuCodeList: [
              "quotation_detail",
              "quotation_report",
              "quotation_summary",
            ],
            submenuItems: [
              {
                label: "Quotation Details",
                link: route.quotation,
                code: "quotation_detail",
              },
              {
                label: "Quotation Report",
                link: route.quotationReport,
                code: "quotation_report",
              },
              {
                label: "Quotation Summary",
                link: route.quotationSummary,
                code: "quotation_summary",
              },
            ],
          },

          {
            label: "Order",
            submenu: true,
            subMenuCodeList: [
              "partial_order",
              "quotation_detail",
              "quotation_report",
              "quotation_summary",
              "order",
              "invoice",
              "order_summary",
              "order_report",
            ],
            submenuItems: [
              {
                label: "Full Orders",
                link: route.order,
                code: "order",
              },
              {
                label: "Partial Orders",
                link: route.partialOrder,
                code: "partial_order",
              },
              {
                label: "Order Reports",
                link: route.orderReport,
                code: "order_report",
              },
              {
                label: "Order Summary",
                link: route.orderSummary,
                code: "order_summary",
              },
            ],
          },

          {
            label: "Invoices",
            link: route.invoice,
            code: "invoice",
          },
        ],
      },
    ],
  },

  {
    submenuOpen: true,
    submenuHdr: "Discovery",
    subMenuCodeList: ["owner", "customer"],
    submenuItems: [
      {
        label: "Discovery",
        icon: "ti ti-users",
        submenu: true,
        subMenuCodeList: ["owner", "customer"],
        submenuItems: [
          {
            label: "Owners",
            link: route.owner,
            code: "owner",
          },
          {
            label: "Customers",
            link: route.customer,
            code: "customer",
          },
        ],
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "USPs",
        icon: "ti ti-list-details",
        link: route.usp,
        code: "usp",
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "Product",
        icon: "ti ti-package",
        link: route.product,
        code: "product",
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "Suppliers",
        icon: "ti ti-truck-delivery",
        link: route.supplier,
        code: "supplier",
      },
    ],
  },

  {
    submenuOpen: true,
    submenuHdr: "Office Use",
    subMenuCodeList: [
      "user",
      "brand",
      "role_access",
      "principal",
      "category",
      "parameter",
      "quotation_format",
      "reason",
      "courier",
      "source",
    ],
    submenuItems: [
      {
        label: "Office Use",
        icon: "ti ti-building",
        submenu: true,
        subMenuCodeList: [
          "user",
          "brand",
          "role_access",
          "principal",
          "category",
          "parameter",
          "quotation_format",
          "reason",
          "courier",
          "source",
        ],
        submenuItems: [
          { label: "Users", link: route.user, code: "user" },
          {
            label: "Roles & Access",
            link: route.roleAcess,
            code: "role_access",
          },
          { label: "Principals", link: route.principal, code: "principal" },
          { label: "Brands", link: route.brand, code: "brand" },
          { label: "Categories", link: route.category, code: "category" },
          { label: "Parameters", link: route.parameter, code: "parameter" },
          {
            label: "Quotation Format",
            link: route.quotationFormat,
            code: "quotation_format",
          },
          { label: "Reason", link: route.reason, code: "reason" },
          { label: "Courier", link: route.courier, code: "courier" },
          { label: "Source", link: route.source, code: "source" },
        ],
      },
    ],
  },

  {
    submenuOpen: true,
    submenuHdr: "Notification",
    subMenuCodeList: ["notifications"],
    submenuItems: [
      {
        label: "Notification",
        icon: "ti ti-bell",
        submenu: true,
        code: "notification",
        subMenuCodeList: ["notifications"],
        submenuItems: [
          {
            label: "Notification Push",
            link: route.notifications,
            code: "notifications",
          },
        ],
      },
    ],
  },
];
